import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import { stepsToTime } from 'StaticBuilder/Utils';
import FinishLaterButton from './FinishLaterButton';

class StaticBuilderProgressBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getPercentDone = this.getPercentDone.bind(this);
    this.getTimeLeft = this.getTimeLeft.bind(this);
  }

  getPercentDone() {
    const numSteps = this.props.showRequestSignature
      ? this.props.numSteps
      : this.props.numSteps - 2;
    return (100 * (this.props.onStep / numSteps)).toFixed(0);
  }

  getTimeLeft() {
    const numSteps = this.props.showRequestSignature
      ? this.props.numSteps
      : this.props.numSteps - 2;
    const numberStepsLeft = numSteps - this.props.onStep;
    return stepsToTime(numberStepsLeft);
  }

  render() {
    return (
      <div className="status-box">
        {this.props.showFinishLaterButton && this.props.isMenuOpen &&
          <FinishLaterButton />
        }
        <div className="status-info">
          {this.getPercentDone()} %&nbsp;
          <span className="percent-complete-text">
            Complete <i>apx. {this.getTimeLeft()}</i>
          </span>
        </div>
        <strong>Section {this.props.onStep + 1}</strong>
        <div className="statusbar">
          <div style={{ width: `${this.getPercentDone()}%` }}>&nbsp;</div>
        </div>
      </div>
    );
  }
}

StaticBuilderProgressBar.defaultProps = {
  onStep: 0,
  numSteps: 1,
  showFinishLaterButton: false,
  isMenuOpen: false,
  showRequestSignature: true,
};

StaticBuilderProgressBar.propTypes = {
  onStep: PropTypes.number,
  numSteps: PropTypes.number,
  showFinishLaterButton: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
  showRequestSignature: PropTypes.bool,
};

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  StaticBuilderReducer,
  onStep: StaticBuilderReducer.step,
  numSteps: StaticBuilderReducer.sectionKeys.length + 1,
  isMenuOpen: StaticBuilderReducer.isMenuOpen,
});

export default StaticBuilderProgressBar;

export const StaticBuilderProgressBarWithRedux = ReactRedux.connect(
  mapStateToProps,
)(StaticBuilderProgressBar);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderProgressBar.jsx